import React, { useState } from "react";
import Scrollbar from "../../../../components/Scrollbar";
import Moment from "moment";
import {
  Table,
  TableBody,
  TableCell,
  TablePagination,
  TableRow,
  Button,
} from "@mui/material";
import MovimientosHeader from "../../../../components/TableHeader/MovimientosHeader";

import { useMutation, useQuery } from "@apollo/client";
import {
  CANCELAR_MOV_BANCARIO,
  LISTAR_MOV_BANCARIOS,
} from "../../../../graphql/bancos";
import Iconify from "../../../../components/Iconify";
const TABLE_HEAD = [
  {
    id: "noOperacion",
    label: "No. de Operación",
    alignRight: false,
  },
  {
    id: "operacion",
    label: "Operación",
    alignRight: false,
  },
  {
    id: "tipoOperacion",
    label: "Tipo de Movimiento",
    alignRight: false,
  },
  {
    id: "fechaOperacion",
    label: "Fecha de Movimiento",
    alignRight: false,
  },
  {
    id: "Monto",
    label: "Monto",
    alignRight: false,
  },
  {
    id: "",
    label: "",
    alignRight: false,
  },
];
const BancosMovimientosTable = ({
  id,
  setOpenDialog,
  setBodyDialog,
  setErrorGraph,
  setOpenSnackBar,
}) => {
  //Obtener Grapqh del Detalle de la cuenta
  const { data, loading, error, refetch } = useQuery(LISTAR_MOV_BANCARIOS, {
    variables: {
      id: id,
    },
  });

  const [cancelarOperacionBancaria] = useMutation(CANCELAR_MOV_BANCARIO);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  if (loading) return <h1>Obteniendo información...</h1>;
  const { listarMovimientosBancarios } = data;
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleDeactivateRecord = async (ids) => {
    try {
      const result = await cancelarOperacionBancaria({
        variables: {
          id: parseInt(ids),
        },
      });
      setOpenSnackBar(true);
      setErrorGraph({
        mensaje: result.data.cancelarOperacionBancaria,
        severity: "success",
      });
      refetch();
    } catch (error) {
      setOpenSnackBar(true);
      setErrorGraph({ mensaje: error.message, severity: "error" });
    }
  };

  return (
    <>
      <Scrollbar>
        <Table>
          <MovimientosHeader headLabel={TABLE_HEAD} />
          <TableBody>
            {listarMovimientosBancarios
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row) => {
                const {
                  id,
                  noOperacion,
                  operacion,
                  tipoOperacion,
                  montoOperacion,
                  fechaOperacion,
                  cuentaId,
                  devengado,
                  eliminado,
                } = row;
                return (
                  <TableRow hover key={id} tabIndex={-1}>
                    <TableCell>{noOperacion}</TableCell>
                    <TableCell>{operacion}</TableCell>
                    <TableCell>
                      {
                        {
                          1: "Ingreso",
                          2: "Egreso",
                        }[tipoOperacion]
                      }
                    </TableCell>
                    <TableCell>
                      {Moment(fechaOperacion).format("DD-MMMM-YYYY")}
                    </TableCell>
                    <TableCell>$ {montoOperacion}</TableCell>
                    <TableCell>
                      <Button
                        value={id}
                        onClick={(e) => {
                          handleDeactivateRecord(id);
                        }}
                        color="error"
                        startIcon={<Iconify icon="eva:close-outline" />}
                      >
                        Cancelar Operación
                      </Button>
                      {/* {!activo ? (
                        <Button
                          color="primary"
                          value={id}
                          startIcon={<Iconify icon="eva:checkmark-outline" />}
                          onClick={(e) => {
                            handleActiveteRecord(id);
                          }}
                        >
                          Activar
                        </Button>
                      ) : (
                        <Button
                          value={id}
                          onClick={(e) => {
                            handleDeactivateRecord(id);
                          }}
                          color="error"
                          startIcon={<Iconify icon="eva:close-outline" />}
                        >
                          Desactivar
                        </Button>
                      )} */}
                    </TableCell>
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
      </Scrollbar>
      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        page={page}
        count={listarMovimientosBancarios.length}
        rowsPerPage={rowsPerPage}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </>
  );
};

export default BancosMovimientosTable;
